// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__24VpC","list":"PatternAutocomplete_list__1D2F7"};